'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { getPathForLocale, ID_TOKEN_COOKIE, useCookieWatcher } from '@whitbread-eos/utils';
import { useTranslation } from '@whitbread-eos/utils/server';
import { InnBLink } from 'business-booker/src/components/innBusiness/InnBLink';
import { useEffect } from 'react';
const Logout = ({ isAuthActive, secureUrl, locale, onLogoutClick })=>{
    const { t } = useTranslation();
    const isTokenSet = useCookieWatcher(ID_TOKEN_COOKIE, 500);
    useEffect(()=>{
        if (!isTokenSet && isAuthActive) {
            window.location.replace(getPathForLocale(locale, 'account/login'));
        }
    }, [
        isTokenSet,
        isAuthActive
    ]);
    const handleLogout = (e)=>{
        e.preventDefault();
        if (!isAuthActive) {
            onLogoutClick();
            return;
        }
        const authIframe = document.getElementById('authIframeInnB');
        // eslint-disable-next-line
        // @ts-ignore
        if (authIframe === null || authIframe === void 0 ? void 0 : authIframe.contentWindow) {
            const message = JSON.stringify({
                action: 'logout'
            });
            // eslint-disable-next-line
            // @ts-ignore
            authIframe.contentWindow.postMessage(message, secureUrl);
        }
    };
    return /*#__PURE__*/ _jsx(InnBLink, {
        href: "/logout",
        className: "block text-base px-4 py-2.5 hover:bg-lightGrey5",
        "data-testid": "Account-Logout-Link",
        onClick: handleLogout,
        children: t('content.authentication.logoutButton')
    });
};
export default Logout;
